export default __webpack_public_path__ + "static/media/S_INFO_ERP.29168135.rar";